import { QueryClient } from "@tanstack/react-query";
import { productBussiness } from "api/bussiness/product/product-bussiness";
import { createQuery, useStaticQuery } from "./ultilities/base-query";
import {
  buildCatalogCacheKey,
  invalidateCatalogCache,
} from "./ultilities/catalog-cache-key";

export type ProductCatalogRecord = {
  dealingName: string;
  name: string;
  code: string;
  barcode: string;
};

export const PRODUCT_CATALOG_CACHE_KEY = buildCatalogCacheKey("product");

const normalizeValue = (value: string | null | undefined): string => {
  return value?.trim() ?? "";
};

const fetchProductCatalog = async (): Promise<ProductCatalogRecord[]> => {
  const res = await productBussiness.searchAllProducts("");
  const items = res.items ?? [];

  return items.map((item) => ({
    dealingName: normalizeValue(item.customer?.dealingName),
    name: normalizeValue(item.name),
    code: normalizeValue(item.code),
    barcode: normalizeValue(item.barcode),
  }));
};

export const useProductCatalogCache = () => {
  return useStaticQuery(PRODUCT_CATALOG_CACHE_KEY, fetchProductCatalog);
};

export const prefetchProductCatalogCache = async (queryClient: QueryClient) => {
  await queryClient.prefetchQuery(
    createQuery(PRODUCT_CATALOG_CACHE_KEY, fetchProductCatalog, "static"),
  );
};

export const invalidateProductCatalogCache = async (
  queryClient: QueryClient,
) => {
  await invalidateCatalogCache(queryClient, "product");
};
